<template>
    <div class="bg-white">
        <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
            <div class="max-w-3xl mx-auto text-center">
                <h2 class="text-3xl font-extrabold text-gray-900">How It Works</h2>
                <p class="mt-4 text-lg text-gray-500">Racing Stars gameplay is straightforward and easy to understand. Here's how it works in detail.</p>
            </div>
            <dl class="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
                <div v-for="feature in features" :key="feature.name" class="relative">
                    <dt>
                        <RacingStarsIcon class="absolute h-6 w-6 text-green-500" aria-hidden="true" />
                        <p class="ml-9 text-lg leading-6 font-medium text-gray-900">{{ feature.name }}</p>
                    </dt>
                    <dd class="mt-2 ml-9 text-base text-gray-500">
                        {{ feature.description }}
                    </dd>
                </div>
            </dl>
        </div>
    </div>
</template>
<script>
import RacingStarsIcon from '@/Global/RacingStarsIcon.vue'

const features = [{
        name: 'Before You Get Started',
        description: 'Before playing you should read the information below together with our Terms and Conditions.',
    },
    { name: 'Sign Up', description: 'You must open an account with Racing Stars which will be activated once you have entered your details and passed the age verification checks.' },
    {
        name: 'Purchase Tokens',
        description: 'You will need to purchase play tokens in order to participate in our pools; these can be purchased from cash deposited into your account and details of both your cash balance and token balance. will be displayed in your account. You can top up your cash balance at any time using a debit card (credit cards are not accepted); there is a £5.00 minimum top up.',
    },
    { name: 'Cash Balance', description: 'Your cash balance can be used to purchase play token packages.' },
    { name: 'Play Tokens', description: 'Play tokens cannot be converted back into cash.' },
    { name: 'Prize Pools', description: 'Each entry contributes to the pool and once the minimum threshold is passed the jackpots will grow.' },
    { name: 'Entering', description: 'You can only enter once per day.' },
    { name: 'Contribution', description: 'Each entry into a pool contributes £1 to the prize pool.' },
    { name: 'Race Meetings', description: 'You can enter as many or as few meetings as you wish. There will be individual prize pools for each event.' },
    { name: 'Betting', description: 'Once you have made a selection in every race and clicked the complete button your tokens are ‘spent’ and the relevant amounts added to the pools.' },
    { name: 'Changing Selections', description: 'You can change your selections at any stage up until 2 minutes before the stated start time of the race.' },
    { name: 'Non-Runners', description: 'Any non-runners that have been selected will not score any points.' },
    { name: 'Abandoned Meetings', description: 'If the entire race meeting is abandoned/void then the token will be returned to the customer’s account.' },
    { name: 'Awarding Points', description: 'Points are awarded for every horse that finishes in a position that falls within our points scoring parameters. Point scoring is as detailed.' },
    { name: 'Winning the Jackpot', description: 'The player with the highest number of points wins the jackpot for that meeting. In the event of there being more than one player with the highest number of points the jackpot will be shared equally.' },
    { name: 'Dividends', description: 'Dividends will be rounded to 2 decimal places for example £102.35 rather than simply to £102.' },
    { name: 'Rollovers', description: 'There will be no instances of no winners or ‘rollovers’ due to the prize being awarded to the highest scorer every day.' },
    { name: 'Cash Prizes', description: 'Any cash prizes will be credited to players\' accounts and will remain there until either withdrawn back to their debit card or converted to further play tokens.' },
    { name: 'Contacting Support', description: 'If you have any issues or spot any bugs with our platform, please contact Racing Stars support by emailing support@racingstars.co.uk.' },
]

export default {
    components: {
        RacingStarsIcon,
    },
    setup() {
        return {
            features,
        }
    },
}

</script>
